import React from 'react'

const Contant = () => {
  return (
    <div class="container-xxl py-5">
    <div class="container py-5">
        <div class="row g-5 align-items-center">
            <div class="col-lg-5 wow fadeInUp" data-wow-delay="0.1s">
            <h6 class="text-secondary text-uppercase mb-3">Get A Quote</h6>
<h1 class="mb-5">Request a Free Quote Today!</h1>
<p class="mb-5">
Get customized industrial solutions tailored to your needs. From high-quality tools to complete workshop solutions, we provide top-notch products at competitive prices with timely delivery. Reach out today for a personalized quote!
</p>

                <div class="d-flex align-items-center">
                    <i class="fa fa-headphones fa-2x flex-shrink-0 bg-primary p-3 text-white"></i>
                    <div class="ps-4">
                        <h6>Call for any query!</h6>
                        <h3 class="text-primary m-0">+91-8368771407</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="bg-light text-center p-5 wow fadeIn" data-wow-delay="0.5s">
                    <form>
                        <div class="row g-3">
                            <div class="col-12 col-sm-6">
                                <input type="text" class="form-control border-0" placeholder="Your Name"/>
                                {/* style="height: 55px;"  */}
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="email" class="form-control border-0" placeholder="Your Email" />
                                {/* style="height: 55px;" */}
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" class="form-control border-0" placeholder="Your Mobile"  />
                                {/* style="height: 55px;" */}
                            </div>
                            <div class="col-12 col-sm-6">
                            <input type="text" class="form-control border-0" placeholder="Subject"/>
                             {/* style="height: 55px;" */}
                            </div>
                            <div class="col-12">
                                <textarea class="form-control border-0" placeholder="Special Note"></textarea>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-primary w-100 py-3" type="submit">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Contant